// src/pages/OrderViewer/components/OrdersListStep.tsx
import React from "react";
import { CircularProgress } from "@mui/material";
import CardSection from "../../../components/ui/CardSection";
import Button from "../../../components/ui/Button";
import { OrderSummary } from "../types";
import OrderListItem from "./OrderListItem";
import { ErrorBanner, LoadingBox } from "../styles";

interface OrdersListStepProps {
  phone: string;
  orders: OrderSummary[];
  loading: boolean;
  error: string | null;
  onSelectOrder: (order: OrderSummary) => void;
  onBack: () => void;
}

const OrdersListStep: React.FC<OrdersListStepProps> = ({
  phone,
  orders,
  loading,
  error,
  onSelectOrder,
  onBack,
}) => {
  return (
    <CardSection
      icon="receipt"
      title="Últimos pedidos para o telefone"
      sub={`Telefone: ${phone}`}
    >
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
        <Button variant="ghost" size="sm" onClick={onBack}>
          Alterar telefone
        </Button>
      </div>

      {loading && (
        <LoadingBox>
          <CircularProgress size={28} />
        </LoadingBox>
      )}

      {error && <ErrorBanner>{error}</ErrorBanner>}

      {!loading && !error && orders.length === 0 && (
        <ErrorBanner $tone="info">
          Nenhum pedido encontrado para este telefone.
        </ErrorBanner>
      )}

      {!loading && orders.length > 0 && (
        <div>
          {orders.map((order) => (
            <OrderListItem key={order.id} order={order} onClick={() => onSelectOrder(order)} />
          ))}
        </div>
      )}
    </CardSection>
  );
};

export default OrdersListStep;
